import React from 'react'

import { formatName } from '@paintscout/util/builder'
import Highlight from '../../Highlight'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityFooter from '../ActivityFooter'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'

export default function DealActivity(props: ActivityTypeComponentProps) {
  const { activity } = props
  const activityType = activity.details?.activityType
  const action = (activityType || '').replace('deal-', '')

  const ownerToDisplay = activityType === 'deal-assigned' ? activity.details.quoteOwner : activity.details.owner

  return (
    <>
      <ActivityTitle>
        <Highlight>Deal</Highlight> was <Highlight>{action}</Highlight>{' '}
        {!ownerToDisplay ? '' : activityType === 'deal-assigned' ? 'to' : 'by'}
        {'  '}
        <Highlight>{formatName(ownerToDisplay)}</Highlight>
      </ActivityTitle>
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={true} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
